import FullPageModal from "@/modules/common/components/ui-kit/full-page-modal/full-page-modal";
import { Track } from "../../types";
import TenantsTab from ".";

function TenantsMobileTab({
  open,
  onClose,
  track,
}: Readonly<{
  open: boolean;
  onClose: () => void;
  track: Track;
}>) {
  return (
    <FullPageModal isOpen={open} onClose={onClose} title="Tenants">
      <TenantsTab propertyUid={track.property.uid} />
    </FullPageModal>
  );
}

export default TenantsMobileTab;
